import { Injectable } from '@angular/core';
import { ColumnForSelection } from '../import/column-for-selection';

import { DataService } from '../network/data.service';
import { PreaggregationCheckResult, PreaggregationStrategySelectionModel } from './preaggregation-check-result';
import { PreaggregationStrategy } from './preaggregation-strategy';
import { AggregationSettings } from './aggregation-settings';

@Injectable()
export class AggregationSevice {

    constructor(private dataService: DataService) {
    }

    public async requiresPreaggregation(projectId: string): Promise<boolean> {
         return (await this.getPreaggregationCheckResult(projectId)).requiresPreaggregation;
    }

    private getPreaggregationCheckResult(projectId: string): Promise<PreaggregationCheckResult> {
        return this.dataService.get<PreaggregationCheckResult>('aggregation/checkForPreaggregation/' + projectId);
    }

    public getPreaggregationStrategyModel(projectId: string): Promise<PreaggregationStrategySelectionModel> {
        return this.dataService.get<PreaggregationStrategySelectionModel>('aggregation/getPreaggregationStrategyModel/' + projectId);
    }

    public savePreaggregationStrategy(projectId: string, selectedStrategy: PreaggregationStrategy): Promise<boolean> {
        return this.dataService.post<boolean>('aggregation/savePreaggregationStrategy', {
            projectId: projectId,
            selectedStrategy: PreaggregationStrategy[selectedStrategy],
        });
    }

    public getAggregationSettings(projectId: string): Promise<AggregationSettings> {
        return this.dataService.get<AggregationSettings>('aggregation/settings/' + projectId);
    }
}